import React, { useEffect } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input } from 'reactstrap'
import { useState } from 'react';
import travelImage from "../../assets/images/scanMe/main_travel_image.png"
import { Button, Typography, Grid, Skeleton } from '@mui/material';
import { toast } from 'react-toastify';
import { getCountriesByCoverId } from '../../api';

const ScanmeLanding = ({ travellerData, onPassportMatch, onPassportChange }) => {

    const [travellerName, setTravellerName] = useState('')
    const [travelCareMembership, setTravelCareMembership] = useState(null)
    const [passport, setPassport] = useState(null)
    const [inputPassport, setInputPassport] = useState('')
    const [alertFlag, setAlertFlag] = useState(false)

    useEffect(() => {
        if (travellerData) {
            const data = travellerData[0]?.travellers?.[0]
            if (data) {
                setTravellerName(data.firstName)
                setPassport(data.traveller_passport)
            }
            setTravelCareMembership(travellerData[0]?.document_unique_code)

            // Prefetch / lazy load geographical cover countries in background
            const geoCoverId = travellerData[0]?.geographical_cover_id || travellerData[0]?.geographical_cover?.id;
            const existingCountries = travellerData[0]?.geographical_cover?.geo_cover_countries;
            if (geoCoverId && (!existingCountries || existingCountries.length === 0)) {
                getCountriesByCoverId(geoCoverId)
                    .then((res) => {
                        const rawData = res?.data?.data || res?.data?.result || (Array.isArray(res?.data) ? res?.data : []);
                        if (rawData && rawData.length > 0 && travellerData[0]) {
                            if (!travellerData[0].geographical_cover) {
                                travellerData[0].geographical_cover = {};
                            }
                            travellerData[0].geographical_cover.geo_cover_countries = rawData;
                        }
                    })
                    .catch((err) => {
                        console.error("Error prefetching cover countries:", err);
                    });
            }
        }
    }, [travellerData])

    useEffect(() => {
        if (inputPassport && inputPassport.length === passport?.length) {
            if (inputPassport && inputPassport === passport) {
                onPassportMatch()
                toast.success('Welcome')
            } else if (!alertFlag) {
                setAlertFlag(true)
                toast.info('Wrong Passport Number')
            }
        }
    }, [inputPassport, passport, onPassportMatch])

    const inputPassportChangeHandler = (e) => {
        const newPassport = e.target.value
        setInputPassport(newPassport)
        setAlertFlag(false)
        onPassportChange(newPassport)
    }

    // Check if travellerData is still loading
    const isLoading = !travellerData;

    return (
        <>
            <Container>
                <Grid container justifyContent="center" spacing={2} style={{ marginTop: '16px' }}>
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Grid container justifyContent="center" className='position-relative'>
                            {isLoading ? (
                                <Skeleton variant="rectangular" width="100%" height={250} />
                            ) : (
                                <>
                                <img
                                    className="img-fluid for-light"
                                    src={travelImage}
                                    alt="scanMePage"
                                    style={{ borderRadius: '0px 40px 0px 40px', width: '100%', maxWidth: '550px' }}
                                />
                                 {/* <Button
                                                                variant="outlined" // This is a good starting point for a button with a border
                                                                sx={{
                                                                    position: 'absolute',
                                                                    bottom: '26%', // Adjust as needed
                                                                    left: '50%',
                                                                    transform: 'translateX(-50%)', // Horizontally centers the button
                                                                    backgroundColor: 'transparent',
                                                                    borderRadius: '20px',      // User specified, adjust if you want more oval
                                                                    color: 'white',            // Text color
                                                                    textTransform: 'none',
                                                                    borderColor: 'white',      // Sets the border color to black
                                                                    borderWidth: '1.5px',      // Adjust thickness as needed
                                                                    padding: '2px 6px',       // Adjust padding for desired size
                                                                    fontSize: '1rem',          // Adjust font size
                                                                    fontWeight: 500,
                                                                    zIndex: 1,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Slight dark overlay on hover
                                                                        borderColor: 'black', // Keep border color black on hover
                                                                        color: 'white',       // Keep text color white on hover
                                                                    },
                                                                    position:'absolute'
                                                                    // ml: 3 is removed as it's not suitable for absolute centered positioning
                                                                }}
                                                        > Discover</Button> */}
                                </>
                            )}
                        </Grid>
                        <Grid container style={{ fontFamily: 'Poppins', marginTop: '10px' }}>
                            <Grid item xs={12}>
                                {isLoading ? (
                                    <Skeleton width="80%" height={40} />
                                ) : (
                                    <Typography style={{ fontWeight: '275', fontSize: '18px', lineHeight: '54px', letterSpacing: '10%' }}>
                                        hello,
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                {isLoading ? (
                                    <Skeleton width="60%" height={50} />
                                ) : (
                                    <Typography style={{ fontWeight: '800', fontSize: '24px', marginTop: '-32px', lineHeight: '54px', letterSpacing: '0%' }}>
                                        {travellerName}!
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container className="mb-3">
                            <Grid item xs={12}>
                                {isLoading ? (
                                    <Skeleton width="50%" height={30} />
                                ) : (
                                    <Typography variant="body1" style={{ fontWeight: '275', fontSize: '14px' }}>
                                        Please help us in authenticating if it's really you!
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} className="mb-3">
                            <Grid item xs={12} sm={6}>
                                {isLoading ? (
                                    <Skeleton width="100%" height={40} />
                                ) : (
                                    <>
                                        <Typography style={{ fontWeight: '700', textAlign: 'center', fontSize: '14px', marginTop: '5px' }}>
                                            Travel Care Membership #
                                        </Typography>
                                        <Button
                                            color="primary"
                                            style={{ width: '100%', height: '50px', borderRadius: '50px', backgroundColor: '#00239c', color: 'white', marginTop: '10px' }}
                                        >
                                            <span style={{ fontSize: '14px' }}>{travelCareMembership}</span>
                                        </Button>
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {isLoading ? (
                                    <Skeleton width="100%" height={40} />
                                ) : (
                                    <>
                                        <Typography style={{ fontWeight: '700', textAlign: 'center', fontSize: '14px', marginTop: '5px' }}>
                                            Passport Number
                                        </Typography>
                                        <Input
                                            style={{ backgroundColor: '#00239c', width: '100%', height: '50px', borderRadius: '50px', color: '#ffffff', textAlign: 'center', marginTop: '10px' }}
                                            className="stepper-next-btn"
                                            value={inputPassport}
                                            onChange={inputPassportChangeHandler}
                                            placeholder="Enter Passport Number"
                                        />
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default ScanmeLanding;
